import React from 'react';
import { sanitizeText } from '../../../utils/regex.utils';

const HiglightedOption = (newprops: { keyword: string; optionText?: string }): JSX.Element => {
  const { keyword, optionText } = newprops;
  const pattern = new RegExp(`(${sanitizeText(keyword)})`, 'gi');
  const parts = optionText?.split(pattern);

  return <>{keyword === '' ? optionText : parts?.map((part, i) => <>{i % 2 ? <b>{part}</b> : <>{part}</>}</>)}</>;
};

export default HiglightedOption;
